import { objectToQueryString } from '~/utils/common';
const PREFIX_API = 'v2/volta';
export const EventService = {
    getEvent: `${PREFIX_API}/getEvent`,
    getLinkEvent: `${PREFIX_API}/getLiveLink`,
    getUserByToken: `${PREFIX_API}/getUserByToken`,
    getBalanceUser: `${PREFIX_API}/getBalanceUser`,
    postPlaceBetting: `${PREFIX_API}/place-bet`,
    getPlayerStatistics: (eventId) => `${PREFIX_API}/player-statistics?${objectToQueryString({ eventId })}`,
};
